<app-alert [text]="'new_service_successfully_deleted' | translate" [type]="1" *ngIf="showSuccessDeleteServiceAlert"
  (closeAlertEvent)="onAlertClosed()"></app-alert>

<section [ngClass]="{ 'scrollable-table': isHomePage, 'home-datatable-border': isHomePage }">
  <table class="table" *ngIf="showDataWithLimit.length; else emptyHomePage">
    <thead>
      <tr>
        <th scope="col">{{ 'orderHash' | translate }}</th>
        <th scope="col">{{ 'plateNumber' | translate }}</th>
        <th scope="col">{{ 'PickupTime_Column' | translate }}</th>
        <th scope="col">{{ 'service_date' | translate }}</th>
        <th scope="col">{{ 'ServiceReporter' | translate }}</th>
        <th scope="col">{{ 'service' | translate }}</th>
        <th scope="col">{{ 'pickUp' | translate }}</th>
        <th scope="col">{{ 'return' | translate }}</th>
        <th scope="col">{{ 'driver' | translate }}</th>
        <th scope="col">{{ 'status' | translate }}</th>
        <th scope="col" *ngIf="!isHomePage">&nbsp;</th>
      </tr>
    </thead>
    <tbody *ngIf="!loading">
      <tr *ngFor="let data of showDataWithLimit"
        (contextmenu)="$event.preventDefault(); openContextMenu($event, data.orderHash)"
        (click)="handleRowClick($event, data.orderHash)">
        <td class="py-3 td-title">{{ data.orderHash }}</td>
        <td class="py-3"><app-plate-number [plateValue]="data.plateNumber"></app-plate-number></td>
        <td class="py-3">{{ isTransitService(data) ? '-' : data.hour }}</td>
        <td class="py-3">{{ data.date }}</td>
        <td class="py-3">{{ data.serviceReporter == "" ? '-' : data.serviceReporter }}</td>
        <td class="py-3 td-services">
          <ng-container *ngFor="let productKey of data.productKeys">
            <app-service-icons [isDatatable]="true" [ServiceProductKey]="productKey"
              [newServiceIcons]="true"></app-service-icons>
          </ng-container>
        </td>
        <td class="py-3 text-overflow-ellipsis">{{ data.pickUpAddress }}</td>
        <td class="py-3 text-overflow-ellipsis">
          {{ data.returnAddress ? data.returnAddress : data.pickUpAddress }}
        </td>
        <td class="py-3">{{ data.driver ? data.driver : ' - ' }}</td>
        <td class="py-3"><app-status [statusValue]="data.status"></app-status></td>
        <td class="" *ngIf="!isHomePage">
          <app-more-options-table-row [menuOptions]="data.MoreOptionData"
            (optionEmitter)="moreOptionsAction($event, data)"></app-more-options-table-row>
        </td>
      </tr>
    </tbody>
  </table>

  <div *ngIf="showDataWithLimit.length && !isHomePage && !loading"
    class="d-flex flex-row justify-content-between align-items-center">

    <app-table-paginator [currentPage]="page" [pageAmount]="pageCount"
      (pageEmitter)="setPage($event)"></app-table-paginator>
  </div>

  <ng-template #emptyHomePage>
    <div *ngIf="isHomePage && !loading" class="d-flex flex-column align-items-center w-100 no-services-content">
      <div class="empty-home-page d-flex flex-column align-items-center">
        <img src="../../../assets/empty-home-services.svg" alt="Empty home page" />
        <h4>{{ 'nothingInView' | translate }}</h4>
        <p class="text-center">{{ 'noServicesToday' | translate }}</p>
      </div>
    </div>
    <div *ngIf="(isMyServicesToday || isMyServicesNext || isMyServicesHistory || isActiveRoutesDatatable) && !loading"
      class="d-flex flex-column align-items-center w-100">
      <div class="d-flex flex-column align-items-center w-25">
        <img src="../../../assets/icons/no-active-services.svg" alt="No active routes available" />
        <div class="no-service-div">
          <h2 class="text-center my-services-h2">{{ 'noServicesInSight' | translate }}</h2>
          <p class="text-center my-services-p">{{ 'save_time' | translate }}</p>
        </div>

        <div class="service-button" [routerLink]="['/new-service']">
          <div class="service-text">{{ 'request_service' | translate }}</div>
        </div>

      </div>
    </div>
  </ng-template>

  <app-spinner-datatable *ngIf="loading"></app-spinner-datatable>
</section>